module.exports = __webpack_public_path__ + "img/junkers9000i.deeb5424.jpeg";